/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Nomyarticles2Inputs */



/**

* @param {_Wiki_Nomyarticles2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_nomyarticles2 = /** @type {((inputs?: _Wiki_Nomyarticles2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Nomyarticles2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Du hast noch keine Artikel erstellt")
});
export { _wiki_nomyarticles2 as "_wiki_noMyArticles" }